import React, { useMemo } from 'react';
import {
	ExpandElementProps,
	FetchAllDataSource,
	PagedTable,
	TableColumnType,
} from '@tunz/data-tables';
import { UserProfile } from '../../../Services/ModuleService';
import { GET_CURRENT_USER_ROLES } from '../../../Services/Constants';

type UserRole = {
	role: string;
	application: string;
};

const CurrentUserRoles: React.FC<ExpandElementProps<UserProfile>> = ({ record }) => {
	const datasource = useMemo(
		() => new FetchAllDataSource<UserRole[]>(GET_CURRENT_USER_ROLES(record)),
		[record],
	);

	const columns: TableColumnType[] = [
		{
			name: 'Roles',
			field: 'role',
			filtered: true,
			filterType: 'text',
			isKey: true,
		},
		{
			name: 'Applications',
			field: 'application',
			filtered: true,
			filterType: 'text',
			isKey: true,
		},
	];

	const title = `Roles for ${record.profile}`;

	return (
		<div className="w-35 current_user_info">
			<PagedTable title={title} columns={columns} datasource={datasource} />
		</div>
	);
};

export default CurrentUserRoles;
